import {toast} from 'react-toastify';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setLocation, setName,setDob } from './redux/chatSlice';
function Profile ({closeModal}){
const [formData,setFormData]=useState({name:'',location:'',dob:''});
const dispatch= useDispatch();

    const handlePost=async()=>{
        if(!formData.name || !formData.location || !formData.dob ){
            alert('please fill everything');
            return;
        };
        dispatch(setName(formData.name));
        dispatch(setDob(formData.dob));
        dispatch(setLocation(formData.location));

      toast.success(' Profile updated successfully');
      closeModal();
    }
      const handleChange=(e)=>{
      const{name,value}=e.target;
      setFormData({...formData,[name]: value});
      };

    return(
<div className='overlay'>  
<div className="glass-pop" style={{display:'flex',flexDirection:'column',padding:'10px'}}>
   <div className="header"style={{display:'flex',columnGap:'40px'}}>
     <h3 style={{whiteSpace:'nowrap'}}>Edit Profile</h3>
     <h4 style={{paddingRight:'30px'}} onClick={closeModal}>X</h4>
     </div>
<hr></hr>
     <label><b>Name</b></label>
     <input type='text' className='m' name='name' value={formData.name} onChange={handleChange} style={{padding:'3px',width:'90%',outline:'none',border:'1px solid grey',margin:'10px'}}/>
    <label><b>Location</b></label>
    <input type='text' className='y'  name='location' value={formData.location} onChange={handleChange} style={{padding:'3px',width:'90%',outline:'none',border:'1px solid grey',margin:'10px'}}/>
    <label><b>Date of Birth</b></label>
    <input type='date' className='o'  name='dob' value={formData.dob} onChange={handleChange} style={{padding:'3px',width:'90%',outline:'none',border:'1px solid grey',margin:'10px'}}/>
<hr></hr>
    <div className='d-flex' style={{paddingLeft:'60%',margin:'20px',gap:'7px'}}>
   <button className='btn btn-primary' onClick={handlePost}>Save</button>
   <button onClick={closeModal} className='btn btn-secondary' >close</button>
   </div>
</div>
</div>
    );
};

export default Profile;
